import React, { JSX } from 'react';
import { useIntl } from 'react-intl';

import { Locales } from '../../../constants/common-constants';
import { useLocale } from '../../../context';
import { useStyles } from './language-switcher.styles';

export const LanguageSwitcher = (): JSX.Element => {
  const { locale, setLocale } = useLocale();
  const classes = useStyles();
  const intl = useIntl();

  const handleSetLocale = () => {
    setLocale(locale === Locales.en ? Locales.ua : Locales.en);
  };

  return (
    <button
      className={classes.root}
      name="switcher"
      id="switcher"
      onClick={handleSetLocale}
      aria-label={intl.formatMessage({ id: 'language.switcher.ariaLabel', defaultMessage: '' })}
    >{locale === Locales.ua ? 'Eng' : 'Укр'}
    </button>
  );
};
